import React, { Component } from 'react';
import {LanguageSwitcher} from './LanguageSwitcher';
import {FAQLink} from './FAQLink';
class FAQ extends Component {
    render() {
        return(
            <div id="faqContainer">
                <div id="control" className="purpleBgd">
                    <div id="rightMenu">
                        <FAQLink showFAQ={this.props.showFAQ} />
                        <LanguageSwitcher changeLang={this.props.changeLang}
                                          lang={this.props.lang} />
                    </div>
                </div>
                <div id="content">
                    FAQs
                </div>
            </div>
        );
    }
}

export default FAQ;


// WEBPACK FOOTER //
// ./src/components/FAQ.jsx